module.exports = __webpack_public_path__ + "static/img/thimg2.8cc67597.png";